/**
 * US-85: форматирование ФИО согласантов / «у кого на согласовании» для баннеров
 * статуса недельного таймшита. Вынесено из TimesheetGrid в отдельный модуль —
 * чистые функции легко покрыть unit-тестами (как absenceMeta.ts), не поднимая
 * тяжёлый рендер всей сетки.
 */
import type { PendingApprover, TimesheetWeekDetail } from "../api/client";

/**
 * «У кого сейчас на согласовании» — строка через запятую, делегаты помечены.
 * Пустая строка, если список пуст (backend отдаёт его только для статусов
 * на согласовании; на остальных — []).
 */
export function formatPendingWith(pending: PendingApprover[] | undefined): string {
  if (!pending || pending.length === 0) return "";
  return pending
    .map((p) => (p.is_delegate ? `${p.full_name} (делегат)` : p.full_name))
    .join(", ");
}

/**
 * «Кто согласовал» для финального статуса `approved`. Собираем PM и ЛР, если
 * их ФИО известны (не null). Возвращаем пустую строку, если согласантов нет
 * (например, автосогласование top-level ЛР / PM-автора — backend вернул null,
 * чтобы не показывать «согласовал сам себя»).
 *
 * Порядок: сначала PM (финальный согласант), затем ЛР — отражает цепочку
 * «снизу вверх» к закрытию недели.
 */
export function formatApprovedBy(
  detail: Pick<TimesheetWeekDetail, "lr_approved_by_name" | "pm_approved_by_name">,
): string {
  const parts: string[] = [];
  if (detail.pm_approved_by_name) parts.push(`PM: ${detail.pm_approved_by_name}`);
  if (detail.lr_approved_by_name) parts.push(`ЛР: ${detail.lr_approved_by_name}`);
  return parts.join("; ");
}
